export const BUSINESS_ROUTER = {
	pricing: `pricing`
}
